module.exports = __webpack_public_path__ + "img/zuo@2x.217064f7.png";